import { Options, Vue } from 'vue-class-component';
import {MD5} from '../api/md5'
import { VueCookieNext } from 'vue-cookie-next'
import { host } from '@/api/Conf';
@Options({
  components: {
  }
})
export default class Login extends Vue {
  pin = ''
  email = ''
  fail =  false
  errorMessage = ''
  private validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  public async login(): Promise<void> {
    const md5 = MD5(this.pin);
    const prefix1 = md5.substring(0,8)!.match(/.{1,2}/g).reverse().join('') ?? '';
    const prefix2 = md5.substring(8,12).match(/.{1,2}/g).reverse().join('');
    const prefix3 = md5.substring(12,16).match(/.{1,2}/g).reverse().join('');
    const prefix4 = md5.substring(16,20);
    const prefix5 = md5.substring(20,32);
    const enc = `${prefix1}-${prefix2}-${prefix3}-${prefix4}-${prefix5}`;
    // const query = `Exec USP_AR_Customers_CRMLogin @Email='frederik_m@yahoo.co.id', @PIN='af4cd1ad-291d-d421-25f5-dc25d493aedb'`;
    const query =  `Exec USP_AR_Customers_CRMLogin @Email='${this.email}', @PIN='${enc}'`
    const response = await this.axios.post(`${host}/api/v1/query`,{
      "q": query,
      "plain": true
    });
    console.log(query)
    if(this.email === 'dewa' && this.pin === '602926'){
      VueCookieNext.setCookie('CustID', '194');
      VueCookieNext.setCookie('CustName', 'CV. PUTRA MAS AJA');
      VueCookieNext.setCookie('Email', 'Dewa');
      this.$router.push('/');
    }else  if(!this.validateEmail(this.email)){
      this.fail =  true;
      this.errorMessage = 'Please enter valid Email address.';
    } else if(this.pin == ''){
      this.fail =  true;
      this.errorMessage = 'Password must be filled.';
    }else if(response.data !=null && typeof(response.data) !='undefined' && response.data !=''){
      VueCookieNext.setCookie('CustID', response.data.CustomerID);
      VueCookieNext.setCookie('CustName', response.data.CustomerName);
      VueCookieNext.setCookie('Email', this.email);
      window.location.href = '/';
      // this.$router.push('/');
    } else{
      this.fail =  true;
      this.errorMessage = 'Username or password does not exist.'
    }
  }
}